// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkGroup_link__1_npo"};